/**
 * Quantity formats for the Part Demand dashboard, in the reader's language: whole units for pieces, up to 2
 * decimals for other units (inches, pounds)
 */

const locale = (language: string) =>
  language.startsWith('fr') ? 'fr-CA' : 'en-CA';

const DISCRETE = ['EA', 'PC', 'PCS', 'KIT', 'SET'];

export const formatQty = (value: number, uom: string, language: string) =>
  new Intl.NumberFormat(locale(language), {
    maximumFractionDigits: DISCRETE.includes(uom.toUpperCase()) ? 0 : 2,
  }).format(value);

/** An average a month, which can be a fraction of a unit (0.2 a month) whatever the unit */
export const formatAverage = (value: number, language: string) =>
  new Intl.NumberFormat(locale(language), {
    maximumFractionDigits: value < 10 ? 2 : 1,
  }).format(value);

/** A customer row's name: its ship-to's (which already names the customer), or the customer's for returns */
export const customerLabel = (c: {
  customerName: string;
  custId: string;
  shipToName: string;
}) => c.shipToName || c.customerName || c.custId;

/** Series colors, in the dashboard's fixed order (the first three as Quote-to-Cash's) */
export const DEMAND_COLORS = {
  customer: '#2a78d6',
  internal: '#eb6834',
  events: '#1baf7a',
  returns: '#a8a29e',
  average: '#52514e',
};
